import axios from 'axios';
import { apiUrl } from '../Config';

const getAuthToken = () => {
    return localStorage.getItem('authToken');
}

export const GetBenifits = async () => {
    try {
        const response = await axios.get(`${apiUrl}/benifits/active`, { headers: { Authorization: `Bearer ${getAuthToken()}` } });
        return response.data;
    } catch (error) {
        console.error('Error fetching benifits:', error);
        throw error;
    }
}

export const searchBenefitsApi = async (query) => {
    try {
        const response = await axios.get(`${apiUrl}/benifits/search?q=${encodeURIComponent(query)}`, { 
            headers: { Authorization: `Bearer ${getAuthToken()}` } 
        });
        return response.data;
    } catch (error) {
        console.error('Error searching benefits:', error);
        throw error;
    }
}